import { AccordionDetails, Grid, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { THistoryData } from '../../../../types/history';
import { THistoryDiffData } from '../../../../types/history';
import { useHooks } from './useHooks';
import SubdirectoryArrowLeftIcon from '@material-ui/icons/SubdirectoryArrowLeft';
import { useStyles } from './useStyles';
import { HistoryDiffAccordion } from '../../../atoms/HistoryDiffAccordion';
import { HistoryDiffAccordionSummary } from '../../../atoms/HistoryDiffAccordionSummary';
import { HISTORY_ADDED_DIVISION_DELETED } from '../../../../const/Const';

export type TProps = {
  historyData: THistoryData; // 表示用データ
  apiRequest: (id: number) => Promise<any>; // 差分取得するapiを指定。historyData.idで検索する。apiからのレスポンスが多様なのでanyを利用。
  createHistoryDiffList: (
    apiResponseHistoryDiff: any
  ) => Array<THistoryDiffData>; // apiのレスポンスの差分情報からから画面に表示する差分データを作成する。レスポンスが多様なのでanyを利用。
  callbackRef?: (node: any) => void;
};

export const HistoryDiff: FC<TProps> = props => {
  const { historyData, apiRequest, createHistoryDiffList, callbackRef } = props;
  const { historyDiffDataList, onChange } = useHooks({
    id: historyData.id,
    apiRequest,
    createHistoryDiffList
  });

  const classes = useStyles();

  return (
    <HistoryDiffAccordion onChange={onChange} ref={callbackRef}>
      <HistoryDiffAccordionSummary>
        <Grid container spacing={0}>
          <Grid item xs={4}>
            <Typography>更新日時</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography>{historyData.addedAt}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>更新者</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography className={classes.breakWord}>
              {historyData.user}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.breakWord}>
              {historyData.text}
            </Typography>
          </Grid>
        </Grid>
      </HistoryDiffAccordionSummary>
      <AccordionDetails className={classes.diffDetail}>
        {historyDiffDataList && (
          <Grid container spacing={0}>
            {historyDiffDataList.map((historyDiffData, index) => {
              if (
                historyData.addedDivision === HISTORY_ADDED_DIVISION_DELETED
              ) {
                return (
                  <React.Fragment key={`${historyDiffData.targetId}-${index}`}>
                    <Grid item xs={4}>
                      <Typography>{historyDiffData.title}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography
                        className={`${classes.previousText} ${classes.breakWord}`}
                      >
                        {historyDiffData.target !== null &&
                        historyDiffData.target !== undefined
                          ? historyDiffData.target
                          : ''}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                );
              }
              if (historyDiffData.hasDiff) {
                return (
                  <React.Fragment key={`${historyDiffData.targetId}-${index}`}>
                    <Grid item xs={4}>
                      <Typography>{historyDiffData.title}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography className={classes.breakWord}>
                        {historyDiffData.target !== null &&
                        historyDiffData.target !== undefined
                          ? historyDiffData.target
                          : ''}
                      </Typography>
                    </Grid>
                    {historyDiffData.previous !== null &&
                      historyDiffData.previous !== undefined && (
                        <>
                          {/* 項目名分の空白 */}
                          <Grid item xs={4} />
                          <Grid item xs={8}>
                            <SubdirectoryArrowLeftIcon
                              className={classes.arrow}
                            />
                            <Typography
                              component='span'
                              className={`${classes.previousText} ${classes.breakWord}`}
                            >
                              {historyDiffData.previous}
                            </Typography>
                          </Grid>
                        </>
                      )}
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </Grid>
        )}
      </AccordionDetails>
    </HistoryDiffAccordion>
  );
};
